import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";

const ApplyModal = ({ show, onClose, job }) => {
    const fileRef = useRef(null);

    const [fileName, setFileName] = useState("");
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm();

    // ================= SUBMIT FUNCTION =================
    const applyJob = async (data) => {
        const cvFile = data.cv?.[0];
        console.log("cvFile:", cvFile, data.cv); // now it will log correctly
 
        if (!cvFile) return;

        const formData = new FormData();
        formData.append("c_id", job?.c_id);
        formData.append("name", data.name);
        formData.append("mobile", data.mobile);
        formData.append("email", data.email);
        formData.append("cv", cvFile);

        try {
            setLoading(true);

            const res = await fetch(
                "https://api.visko.group/api/crm/career/apply-job",
                {
                    method: "POST",
                    body: formData,
                }
            );

            await res.json();

            setShowSuccess(true);
            reset();
            setFileName("");
            onClose();
        } catch (err) {
            console.error("Apply Job Error:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* ================= APPLY MODAL ================= */}
            <Modal show={show} onHide={onClose} centered>
                <Modal.Header className="border-0 pb-0">
                    <div>
                        <h6 className="fw-bold mb-0">Apply for Position</h6>
                        <small className="text-muted">{job?.c_title}</small>
                    </div>
                    <button className="btn-close" onClick={onClose} />
                </Modal.Header>

                <Modal.Body className="pt-3 px-4 pb-4">
                    <form onSubmit={handleSubmit(applyJob)}>
                        {/* FULL NAME */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Full Name <span className="text-danger">*</span>
                            </label>
                            <input
                                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                placeholder="Enter your full name"
                                {...register("name", {
                                    required: "Full name is required",
                                    pattern: {
                                        value: /^[A-Za-z\s]+$/,
                                        message: "Only letters allowed",
                                    },
                                })}
                            />
                            <small className="text-danger">{errors.name?.message}</small>
                        </div>

                        {/* MOBILE */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Mobile Number <span className="text-danger">*</span>
                            </label>
                            <input
                                className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                                placeholder="10 digit mobile number"
                                maxLength={10}
                                {...register("mobile", {
                                    required: "Mobile number is required",
                                    pattern: {
                                        value: /^[0-9]{10}$/,
                                        message: "Enter valid 10 digit number",
                                    },
                                })}
                            />
                            <small className="text-danger">{errors.mobile?.message}</small>
                        </div>

                        {/* EMAIL */}
                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Email Address <span className="text-danger">*</span>
                            </label>
                            <input
                                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                placeholder="yourname@gmail.com"
                                {...register("email", {
                                    required: "Email is required",
                                    pattern: {
                                        value: /^[^\s@]+@gmail\.com$/,
                                        message: "Only Gmail allowed",
                                    },
                                })}
                            />
                            <small className="text-danger">{errors.email?.message}</small>
                        </div>

                        {/* UPLOAD CV */}
                        <div className="mb-4">
                            <label className="form-label fw-semibold">
                                Upload CV <span className="text-danger">*</span>
                            </label>

                            <div
                                className="border rounded p-3 text-center"
                                style={{ borderStyle: "dashed", cursor: "pointer" }}
                                onClick={() => fileRef.current?.click()}
                            >
                                <div className="fw-semibold">
                                    {fileName || "Choose file or drag here"}
                                </div>
                            </div>

                            <input
                                type="file"
                                accept=".pdf,.doc,.docx"
                                style={{ display: "none" }}
                                ref={fileRef}
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setFileName(file?.name || "");
                                    setValue("cv", e.target.files, { shouldValidate: true });
                                }}
                            />

                            <small className="text-danger d-block text-center mt-1">
                                {errors.cv?.message}
                            </small>
                            <small className="text-muted d-block text-center mt-2">
                                PDF or DOC, Max 2MB. We never share your data.
                            </small>
                        </div>

                        {/* SUBMIT */}
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn w-100 py-2 fw-semibold text-white"
                            style={{ backgroundColor: "#ff6a32" }}
                        >
                            {loading ? "Submitting..." : "Submit Application"}
                        </button>
                    </form>
                </Modal.Body>
            </Modal>

            {/* ================= SUCCESS MODAL ================= */}
            <Modal show={showSuccess} centered onHide={() => setShowSuccess(false)}>
                <Modal.Body className="text-center p-4">
                    <div style={successIcon}>✓</div>
                    <h6 className="fw-semibold mt-3">Application Submitted!</h6>
                    <p className="text-muted mt-2" style={{ fontSize: 14 }}>
                        Your profile has been successfully sent to our HR team. We will contact
                        you shortly.
                    </p>
                    <button
                        className="btn w-100 mt-2"
                        style={lightBtn}
                        onClick={() => setShowSuccess(false)}
                    >
                        Go to Home
                    </button>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ApplyModal;

/* ================= STYLES ================= */
const successIcon = {
    width: 48,
    height: 48,
    borderRadius: "50%",
    background: "#22c55e",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 24,
    margin: "0 auto",
};

const lightBtn = {
    background: "#fff",
    border: "1px solid #e5e7eb",
    padding: 10,
    borderRadius: 8,
};
